import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form';

import _get from 'lodash/get';
import _last from 'lodash/last';
import _filter from 'lodash/filter';

import http from '../../shared/http';
import endpoints from '../../../config/endpoints';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';
import createDatePicker from '../../shared/date-picker';

import { createSelectOptionsFromSysEnums } from '../../shared/form-elements/select';
import qs from 'qs';
import createCalendar from '../../shared/calendar';
import moment from 'moment';
import {getFormValues, change} from 'redux-form';

const TOGGLE_PROGRESS_BAR = 'guarantApproveRequestEditor/toggle-progress-bar';
const FETCH_FORM_SUCCESS = 'guarantApproveRequestEditor/FETCH_FORM_SUCCESS';
const FETCH_ERROR = 'guarantApproveRequestEditor/fetch-error';
const GET_EMPTY_DATA = 'guarantApproveRequestEditor/get-empty-data';
const SET_DATA_TO_NULL = 'guarantApproveRequestEditor/set-data-to-null';

const LOOKUP_SUCCESS = `guarantApproveRequestEditor/lookup-success`;
const LOOKUP_ERROR = `guarantApproveRequestEditor/lookup-error`;

const SUBMIT_SUCCESS = `guarantApproveRequestEditor/SUBMIT_SUCCESS`;
const SUBMIT_ERROR = `guarantApproveRequestEditor/SUBMIT_ERROR`;

const calendar = createCalendar({
	namespace: 'guarantApproveRequestEditor',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

const datepicker = createDatePicker({
	namespace: 'guarantApproveRequestEditor',
	stateNodeName: 'datepicker',
	defaultValue: {
		start: moment()
			.format('YYYY-MM-DD')
	}
});

export const allowedPermissions = {
	'view': 'guarant_register_view',
	'edit': 'guarant_register_view',
	'delete': 'guarant_register_view',
	'create': 'guarant_register_view',
	'prolong': 'guarant_register_confirm_prolong'
};

const initialState = {
	data: null,
	showProgressBar: false,
	calendar: calendar.initialState,
	datepicker: datepicker.initialState,
	error: false
};

export const actions = Object.assign({

	fetchData: () => dispatch => {
		const id = getRequestId();

		if (!id || !Number(id)) {
			return dispatch({ type: FETCH_FORM_SUCCESS, payload: { data: [] } });
		}

		const request = http({
			url: `${endpoints.MANUAL_GUARANT_REQUEST.BASE}/${id}`,
			method: 'get',
			actions: [ FETCH_FORM_SUCCESS, FETCH_ERROR ]
		});

		return request(dispatch).then(action => {

			if (action.type === FETCH_FORM_SUCCESS) {
				dispatch(datepicker.actions.datepickerChange(action.payload.data.start));
				dispatch(datepicker.actions.datepickerApply());
			}

		});
	},
	submitForm: formData => (dispatch, getState) => {

		const datepicker = selectors.getDatepicker(getState());
		const id = getRequestId();
		if (Array.isArray(formData.sids)) {
			formData.sids = formData.sids.join(',');
		}
		let data = {
			...formData,
			sids: formData.sids ? formData.sids.replaceAll(' ', '').split(',') : null,
			offer_id: _get(formData, 'offer_id.0.value', null),
			affiliate_id: _get(formData, 'affiliate_id.0.value', null),
			country_id: _get(formData, 'country_id.0.value', null),
			campaign_id: _get(formData, 'campaign_id.0.value', null),
			traffic_source: _get(formData, 'traffic_source.0.value', null),
			duration: _get(formData, 'duration.0.value', null),
			start_leads_setting: _get(formData, 'start_leads_setting.length', null) &&
				formData.start_leads_setting.map(setting => ({
					...setting, start_duration: _get(setting, 'start_duration.0.value', null)
				})),
			starts_at: (datepicker.value.start || datepicker.value)
		};

		return http({
			url: `${endpoints.MANUAL_GUARANT_REQUEST.BASE}${id ? `/${id}` : ''}`,
			method: id ? 'put' : 'post',
			data: data,
			actions: [ SUBMIT_SUCCESS, SUBMIT_ERROR ]
		})(dispatch)
			.then(action => {
				if (action.type === SUBMIT_SUCCESS) {
					dispatch({ type: SET_DATA_TO_NULL });
					browserHistory.push('/limited-garants');
				}
				if (action.type === SUBMIT_ERROR && action.payload.response.status === 400) {
					const responseMessage = action.payload.response.data.message;
					if (responseMessage && responseMessage.split('=')[0] === 'already_created_id') {
						throw new SubmissionError({ _error: responseMessage.split('=')[1] });
						// return browserHistory.push('/guarant-approve-requests/edit/' + responseMessage.split('=')[1]);
					}
				}
			});
	},
	affiliatesLookup: text => dispatch => {
		const request = http({
			url: `${endpoints.LOOKUPS.AFFILIATES}?query=${text}`,
			method: 'get',
			actions: [
				LOOKUP_SUCCESS,
				LOOKUP_ERROR
			]
		});

		return request(dispatch).then(action => {
			if (action.type === LOOKUP_SUCCESS) {
				return {
					options: createSelectOptionsFromSysEnums(action.payload.data)
				};
			}
		});
	},

	locationsLookup: text => (dispatch, getState) => {
		const request = http({
			url: `${endpoints.LOOKUPS.LOCATIONS_WITH_TRAFFIC}?query=${text}`,
			method: 'get',
			actions: [LOOKUP_SUCCESS, LOOKUP_ERROR]
		});

		return request(dispatch).then(action => {
			if (action.type === LOOKUP_SUCCESS) {
				return { options: action.payload.data.map(item => ({ value: item.id, label: item.text })) };
			}
		});
	},
	campaignsLookup: text => (dispatch, getState) => {

		const formData = getFormValues('manualGuarantRequests')(getState());
		const offer_id = _get(formData, 'offer_id.0.value');
		const affiliate_id = _get(formData, 'affiliate_id.0.value');

		if (!offer_id || !affiliate_id) {
			return {
				options: []
			};
		}

		const query = qs.stringify({ offer_id, affiliate_id, query: text });

		const request = http({
			url: `${endpoints.LOOKUPS.CAMPAIGNS}?${query}`,
			method: 'get',
			actions: [LOOKUP_SUCCESS, LOOKUP_ERROR]
		});

		return request(dispatch).then(action => {
			if (action.type === LOOKUP_SUCCESS) {
				return { options: action.payload.data.map(item => ({ value: item.id, label: item.id })) };
			}
		});
	},
	handleAffiliateChange: () => (dispatch, getState) => {
		dispatch(change('manualGuarantRequests', 'offer_id', null));
		dispatch(change('manualGuarantRequests', 'country_id', null));
	},
	handleOfferChange: () => (dispatch, getState) => {
		dispatch(change('manualGuarantRequests', 'country_id', null));
	},
	offersLookup: text => (dispatch, getState) => {
		const formValues = getFormValues('manualGuarantRequests')(getState());

		const request = http({
			url: `${endpoints.LOOKUPS.OFFERS}?${qs.stringify({
				query: text, isShowedRemoved: true, onlyAvailable: true,
				affiliate_id: _get(formValues, 'affiliate_id.0.value', 0)
			})}`,
			method: 'get',
			actions: [ LOOKUP_SUCCESS, LOOKUP_ERROR ]
		});

		return request(dispatch).then(action => {
			if (action.type === LOOKUP_SUCCESS) {
				return { options: action.payload.data.map(item => ({ value: item.id, label: item.text })) };
			}
		});
	},
	setDataToNull: () => ({ type: SET_DATA_TO_NULL }),

	toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),

	getEmptyData: () => ({ type: GET_EMPTY_DATA})
},
calendar.actions,
datepicker.actions
);

const reducers = Object.assign({
	[GET_EMPTY_DATA]: (state, action) => ({
		...state,
		data: {},
		showProgressBar: false
	}),
	[SET_DATA_TO_NULL]: state => ({ ...state, data: null }),
	[LOCATION_CHANGE]: (state, action) => {
		return {
			...initialState
		};
	},
	[FETCH_FORM_SUCCESS]: (state, action) => {
		const data = action.payload.data || {};

		return {
			...state,
			data: {
				...data,
				start_leads_setting: data.start_leads_setting &&
					data.start_leads_setting.map(setting => ({
						...setting, start_duration: [{ value: setting.start_duration, label: setting.start_duration}]
					}))
			},
			showProgressBar: false
		};
	},
	[FETCH_ERROR]: state => ({ ...state, error: true, showProgressBar: false}),
	[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })
},
calendar.reducers,
datepicker.reducers
);

export default handleActions(reducers, { ...initialState });

export const selectors = {
	getData: state => state.guarantApproveRequestEditor.data,
	getInitialValues: state => {
		const data = state.guarantApproveRequestEditor.data || {};
		const selectOptions = selectors.getFormSelectOptions(state);
		return {
			...data,
			offer_id: [{ value: data.offer_id, label: data.offer_name }],
			country_id: [{ value: data.country_id, label: data.location_name }],
			affiliate_id: [{ value: data.affiliate_id, label: data.affiliate_email }],
			campaign_id: [{ value: data.campaign_id, label: data.campaign_id }],
			traffic_source: [{ value: data.traffic_source, label: data.traffic_source }],
			duration: _filter(selectOptions.duration, {
				value: data.duration && `${Object.values(data.duration)[0]} ${Object.keys(data.duration)[0]}`
			})
		};
	},
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getFormSelectOptions: state => {
		const lists = _get(state, 'root.lists', {});
		return {
			traffic_source: createSelectOptionsFromSysEnums(lists['traffic-sources']),
			duration: [
				{ label: '1 days', value: '1 days'},
				{ label: '7 days', value: '7 days'},
				{ label: '14 days', value: '14 days'},
				{ label: '30 days', value: '30 days'}
			]
		};
	},
	getProgressBar: state => state.guarantApproveRequestEditor.showProgressBar,
	getCalendar: state =>
		calendar.selectors.getCalendar(
			state => state.guarantApproveRequestEditor.calendar, state => state
		)(state),
	getError: state => state.guarantApproveRequestEditor.error,
	getDatepicker: state => datepicker.selectors.getDatePicker(
		state => state.guarantApproveRequestEditor.datepicker, state => state
	)(state)
};

function getRequestId() {
	return _last(document.location.pathname.split('/'));
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/limited-garants/editor/index.js